import { Error, Group, Label, Select as BaseSelect } from '@/Components/UI/Form/Partials';
import { useFormInput } from '@/hooks';
import { FormInputProps } from '@/types';

type InputProps = FormInputProps<HTMLSelectElement, {
    options: Array<{ value: string; label: string }>;
}>

export const Select = ({
                           id,
                           name,
                           label,
                           options,
                           required = false,
                           disabled = false,
                           groupClassName,
                           ...rest
                       }: InputProps) => {
    const { value, setValue, error } = useFormInput<string>(name);

    return (
        <Group className={groupClassName}>
            <Label
                htmlFor={id ?? name}
                required={required}
                disabled={disabled}
                invalid={error !== undefined}>
                {label}
            </Label>

            <BaseSelect
                {...rest}
                id={id ?? name}
                name={name}
                value={value ?? ''}
                onChange={(e) => setValue(e.target.value)}
                invalid={error !== undefined}>
                {options?.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </BaseSelect>

            <Error error={error} />
        </Group>
    );
};
